import React, { useEffect, useState } from 'react';
import { Stack } from 'office-ui-fabric-react';
import clsx from 'clsx';
import useWindowDimensions from './hooks/useWindowDimensions';
import Marketing from './pages/Marketing';
import NavigationBar from './components/NavigationBar';
import { isMobileApp, bypassMarketPage } from './utils';
import { login } from './utils/auth';
import 'office-ui-fabric-core/dist/css/fabric.min.css';
import { breakpoints } from './theme.style';
import styles from './App.style';
import './App.css';

const isMobile = isMobileApp();
const shouldBypassMarketPage = bypassMarketPage();

const UnauthenticatedApp = () => {
  const handleLogin = e => {
    e.preventDefault();
    login();
  };

  const { width } = useWindowDimensions();
  const [isSmallScreen, setIsSmallScreen] = useState(width <= breakpoints.lg);

  useEffect(() => {
    setIsSmallScreen(width <= breakpoints.lg);
  }, [width]);

  if (shouldBypassMarketPage) {
    login();
    return <></>;
  }

  return (
    <div className={styles.root}>
      {!isMobile && <NavigationBar />}

      <Stack horizontal>
        <Stack
          className={clsx(
            styles.mainContentContainer,
            isMobile && styles.mobileApp,
            isSmallScreen && styles.smallScreen,
          )}
        >
          <Marketing login={handleLogin} />
        </Stack>
      </Stack>
    </div>
  );
};

export default UnauthenticatedApp;
